import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import "./watershed/watershed.scss";
import L from "leaflet";
import { GestureHandling } from "leaflet-gesture-handling";

/*
 * Initialize the map
 */
const gestureDirections =
  "Select the layer icon to change your view and toggle the watershed's rivers on and off.";
const map = L.map("map", {
  zoomControl: false,
  gestureHandling: true,
  gestureHandlingOptions: {
    text: {
      touch: "Use two fingers to move the map. " + gestureDirections,
      scroll: "Use ctrl + scroll to zoom the map. " + gestureDirections,
      scrollMac: "Use \u2318 + scroll to zoom the map. " + gestureDirections,
    },
    duration: 1500,
  },
}).setView([39.85, -77], 7);

// Check if the device is mobile and adjust the zoom level accordingly
if (window.innerWidth <= 768) {
  map.setZoom(map.getZoom() - 1); // Zoom out by one level on mobile devices
}

/*
 * Set Basemap layers
 */
const topoLayer = L.tileLayer(
  "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
  {
    attribution:
      "Map data: &copy; OpenStreetMap contributors, SRTM | Map style: &copy; OpenTopoMap (CC-BY-SA)",
    maxZoom: 17,
  }
);
const minLayer = L.tileLayer(
  "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
  {
    attribution: "&copy; OpenStreetMap contributors, &copy; CARTO",
    maxZoom: 19,
  }
);
const darkLayer = L.tileLayer(
  "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
  {
    attribution: "&copy; OpenStreetMap contributors, &copy; CARTO",
    maxZoom: 19,
  }
);

const baseMaps = {
  "Light Layer": minLayer,
  "Dark Layer": darkLayer,
  "Topographic Layer": topoLayer,
};

minLayer.addTo(map);

// Toggle map container class for Dark Layer tooltips
map.on("baselayerchange", function (e) {
  if (e.layer === darkLayer) {
    map.getContainer().classList.add("dark-layer-active");
  } else {
    map.getContainer().classList.remove("dark-layer-active");
  }
});

/*
 * Add overlay layers
 */
const promises = [];
const overlayMaps = {};

const rivers = [
  "Choptank River",
  "James River",
  "Nanticoke River",
  "Patapsco River",
  "Patuxent River",
  "Potomac River",
  "Rappahannock River",
  "Susquehanna River",
  "York River",
];

promises.push(
  import("./watershed/data/Chesapeake_Watershed.geo.json").then((geo) => {
    const data = {
      name: "Chesapeake Bay Watershed",
      className: "",
      geo: "Chesapeake_Watershed",
      pane: "watershedPane",
    };
    overlayMaps[data.name] = generateGeoGroup(geo, data);
  })
);
rivers.forEach((riverName) => {
  promises.push(
    import(`./watershed/data/${riverName.replace(" ", "_")}.geo.json`).then(
      (geo) => {
        const data = {
          className: "river-animation",
          pane: "tributariesPane",
          name: riverName,
        };
        overlayMaps[riverName] = generateGeoGroup(geo, data);
      }
    )
  );
});

function generateGeoGroup(geo, data) {
  const river = L.geoJSON(geo, {
    pane: data.pane,
    style: function (feature) {
      return {
        color: "#112c45",
        weight: 3,
        opacity: 1,
        className: data.className,
      };
    },
  });
  const tip = L.geoJSON(geo, {
    pane: data.pane,
    style: function (feature) {
      return {
        color: "#112c45",
        weight: 16,
        opacity: 0,
      };
    },
  }).bindTooltip(data.name, {
    permanent: false,
    sticky: true,
    className: "custom-tooltip",
  });
  map.on("baselayerchange", function (e) {
    if (e.layer === darkLayer) {
      river.setStyle({ color: "#1AC2FF" });
    } else {
      river.setStyle({ color: "#112C45" });
    }
  });

  const group = L.layerGroup([river, tip]);
  group.addTo(map);
  return group;
}

/*
 * Set map panes
 */
map.createPane("watershedPane");
map.createPane("tributariesPane");

// Set z-index for each pane
map.getPane("watershedPane").style.zIndex = 3;
map.getPane("tributariesPane").style.zIndex = 4;

/*
 * Add map controls
 */
L.control
  .zoom({
    position: "bottomright",
  })
  .addTo(map);

//When all geo data has finished importing
Promise.all(promises).then(() => {
  //sort overlay maps alphabetically
  const ordered = Object.keys(overlayMaps)
    .sort()
    .reduce((obj, key) => {
      obj[key] = overlayMaps[key];
      return obj;
    }, {});
  //Add layer controls
  L.control
    .layers(baseMaps, ordered, {
      position: "topright",
    })
    .addTo(map);
});
